import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 28 — GHL Architecture / n8n / HubSpot Pipeline Analytics service links.
 *
 * 9 of 12 Batch 28 posts are platform topics → service-page links.
 * The 3 hiring/role topics (hire-someone-to-connect-n8n-to-gohighlevel,
 * reduce-agency-admin-work-with-automation-va,
 * best-technical-virtual-assistants-for-marketing-agencies) get a homepage
 * contextual link via HIRING_TOPIC_SLUGS instead.
 *
 * See INTERNAL_LINKING_GUIDE.md + CONTENT_OPTIMIZATION_GUIDE.md.
 */
export const BATCH28_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "how-to-automate-client-onboarding-gohighlevel": {
    url: "/gohighlevel-revops-architect",
    anchor: /Automating client onboarding in GoHighLevel/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "outsource-crm-error-handling-and-fallbacks": {
    url: "/gohighlevel-revops-architect",
    anchor: /CRM error handling and fallbacks/i,
    label: "hire a CRM automation architect",
  },
  "automated-lead-nurturing-workflows-for-high-ticket-sales": {
    url: "/gohighlevel-revops-architect",
    anchor: /automated lead nurturing workflows for high-ticket sales/i,
    label: "hire a lead-to-cash automation expert",
  },
  "gohighlevel-snapshot-developer-freelance": {
    url: "/gohighlevel-revops-architect",
    anchor: /freelance GoHighLevel snapshot developer/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "ghl-multi-account-management-expert": {
    url: "/gohighlevel-revops-architect",
    anchor: /GoHighLevel multi-account management expert/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-api-integration-specialist": {
    url: "/gohighlevel-revops-architect",
    anchor: /GoHighLevel API integration specialist/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "setup-hubspot-round-robin-calendar-routing": {
    url: "/hubspot-revops-architect",
    anchor: /HubSpot round-robin calendar routing/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hubspot-sales-hub-implementation-specialist": {
    url: "/hubspot-revops-architect",
    anchor: /HubSpot Sales Hub implementation specialist/i,
    label: "hire a HubSpot RevOps architect",
  },
  "advanced-pipeline-analytics-setup-hubspot": {
    url: "/hubspot-revops-architect",
    anchor: /Advanced pipeline analytics setup in HubSpot/i,
    label: "hire a HubSpot RevOps architect",
  },
};
